import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navigation = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About Us' },
    { path: '/services', label: 'Services' },
    { path: '/franchise', label: 'Franchise' },
    { path: '/customers', label: 'Customers' },
    { path: '/stores', label: 'Stores' },
    { path: '/career', label: 'Career' },
    { path: '/gallery', label: 'Gallery' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <nav style={{
      background: 'var(--bg-primary)',
      borderBottom: '1px solid var(--border-light)',
      padding: '20px 0',
      position: 'sticky',
      top: 0,
      zIndex: 100,
      backdropFilter: 'blur(8px)',
      backgroundColor: 'rgba(255, 254, 242, 0.95)'
    }}>
      <div className="container" style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <Link to="/" style={{
          textDecoration: 'none',
          display: 'flex',
          alignItems: 'center',
          gap: '12px'
        }}>
          <img 
            src="https://customer-assets.emergentagent.com/job_7f41c477-c015-4f39-8756-185b98cacc33/artifacts/abkoigru_Care%20Logo%201200x1200%20Pixel.png" 
            alt="Care Pharmacy" 
            style={{ height: '60px', width: 'auto' }}
          />
        </Link>

        {/* Desktop Navigation */}
        <ul style={{
          display: 'flex',
          alignItems: 'center',
          gap: '32px',
          listStyle: 'none',
          margin: 0,
          padding: 0
        }} className="desktop-nav">
          {navLinks.map((link) => (
            <li key={link.path}>
              <Link
                to={link.path}
                className="navigation-link"
                style={{
                  color: 'var(--text-primary)',
                  textDecoration: 'none',
                  fontSize: '14px',
                  fontWeight: '400',
                  padding: '12px 0',
                  position: 'relative',
                  display: 'block'
                }}
              >
                {link.label}
                {location.pathname === link.path && (
                  <span style={{
                    position: 'absolute',
                    bottom: '8px',
                    left: 0,
                    width: '100%',
                    height: '1px',
                    background: 'var(--text-primary)'
                  }} />
                )}
              </Link>
            </li>
          ))}
        </ul>

        {/* Mobile Menu Toggle */}
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="mobile-menu-toggle"
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            display: 'none',
            padding: '8px'
          }}
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <div style={{
          background: 'var(--bg-primary)',
          borderTop: '1px solid var(--border-light)',
          padding: '24px 0'
        }} className="mobile-nav">
          <div className="container">
            <ul style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              listStyle: 'none',
              margin: 0,
              padding: 0
            }}>
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    onClick={() => setMobileMenuOpen(false)}
                    style={{
                      color: 'var(--text-primary)',
                      textDecoration: 'none',
                      fontSize: '16px',
                      fontWeight: location.pathname === link.path ? '500' : '400',
                      display: 'block',
                      padding: '12px 0'
                    }}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}

      <style>{`
        @media (max-width: 1024px) {
          .desktop-nav {
            display: none !important;
          }
          .mobile-menu-toggle {
            display: block !important;
          }
        }
        
        .navigation-link::after {
          content: '';
          position: absolute;
          bottom: 8px;
          left: 0;
          width: 0;
          height: 1px;
          background: var(--text-primary);
          transition: width 0.5s ease-in-out;
        }
        
        .navigation-link:hover::after {
          width: 100%;
        }
      `}</style>
    </nav>
  );
};

export default Navigation;